import { Button } from '@talentmesh/ui/components/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@talentmesh/ui/components/dialog';
import { TypographyH2 } from '@talentmesh/ui/components/typography';
import { InfoIcon } from 'lucide-react';
import React, { useState } from 'react';
import { ActionButtons } from '../components';
import RecruitmentInformation from '../components/RecruitmentInformation';
import UIStrings from '../utils/UIStrings';
import { RecruitmentCardProps } from './RecruitmentCard';

function RecruitmentCardMobile({
    companyName,
    tests,
    jobAdTitle,
    onBoardUrl,
}: RecruitmentCardProps): React.JSX.Element {
    const [open, setOpen] = useState<boolean>(false);

    return (
        <div className="flex flex-row flex-wrap items-center gap-x-4 gap-y-2">
            <ActionButtons jobAdTitle={jobAdTitle} onBoardUrl={onBoardUrl} />
            <TypographyH2 className="font-bold">{UIStrings.CompleteTalentAssessmentTests(tests.length)}</TypographyH2>
            <Button type="button" variant="ghost" size="icon-sm" onClick={() => setOpen(true)}>
                <InfoIcon className="text-primary" />
                <span className="sr-only">More information</span>
            </Button>

            <Dialog open={open} onOpenChange={setOpen}>
                <DialogContent>
                    <DialogHeader>
                        <DialogTitle>{UIStrings.CompanyIsAFairRecruiter(companyName)}</DialogTitle>
                    </DialogHeader>
                    <RecruitmentInformation tests={tests} />
                </DialogContent>
            </Dialog>
        </div>
    );
}

export default RecruitmentCardMobile;
